export class CreateListGoods {
    typeWarehousing: number;
    note: string;
    empId: number;
    listGoodsId: number;
}